import { FC } from 'react'
import shallow from 'zustand/shallow'

import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useHRSettingsStore } from './HRSettingsStore'
import { AppraisalSeasonInfoBox } from './AppraisalSeasonInfoBox'
import { useAppraisalSeasonOpeningInfo } from '../../../graphql/appraisal-season/useAppraisalSeasonOpeningInfo'

export const HRSettingsAppraisalSeasonTab: FC = () => {
  const [selected] = useHRSettingsStore((state) => [state.selected], shallow)

  const { data, error, loading } = useAppraisalSeasonOpeningInfo(selected.companyId, selected.country)

  if (loading || error || !data || !data.getAppraisalSeasonOpeningInfo) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} showSpinner />
  } else {
    return <AppraisalSeasonInfoBox data={data.getAppraisalSeasonOpeningInfo} />
  }
}
